module.exports = __webpack_public_path__ + "static/nginx-785d62ede8a41f37d4ee5a81997b5b47.jpg";